import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Authorisation from "./Components/Authorisation";
import Dashboard from "./Components/DashBoard";
import ProtectedRoute from "./Components/ProtectedRoute";
import JoinClassPage from "./Components/JoinClassPage";

function App() {
    return (
        <Router>
            <Routes>
                {/* Routes publiques */}
                <Route path="/register" element={<Authorisation />} />
                <Route path="/login" element={<Authorisation />} />

                {/* Routes protégées */}
                <Route element={<ProtectedRoute />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/my-class" element={<Dashboard />} />
                    <Route path="/class/:classId" element={<Dashboard />} />
                    <Route path="/my-results" element={<Dashboard />} />
                    <Route path="/create-test" element={<Dashboard />} />
                    <Route path="/take-test" element={<Dashboard />} />
                    <Route path="/profile" element={<Dashboard />} />
                    <Route path="/result/:quiz_id" element={<Dashboard />} />
                    <Route path="transcription/:transcription_id" element={<Dashboard />} />
                    <Route path="attempt/:quiz_id" element={<Dashboard />} />
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/class/join/:joinCode" element={<JoinClassPage />} />
                </Route>

                <Route path="*" element={<Dashboard />} />
            </Routes>
        </Router>
    );
}

export default App;
